module.exports = __webpack_public_path__ + "static/media/banner_sendero_contigo_1920x420.f4646bd5.jpg";